// extracted by mini-css-extract-plugin
export default {"host":"style_host__VDGVG","webhook":"style_webhook__HD8+Q","url":"style_url__I97iq","compact":"style_compact__mdCww"};